<template>
    <div>
        <div style="display: block;">
            <b-form @submit="search_invoice">
                <div style="max-width: 400px; width: 100%; display: inline-block; vertical-align: top;"><b-form-input size="md" placeholder="SEARCH INVOICE" v-model="search_txt"></b-form-input></div>
                <div style="display: inline-block; vertical-align: top;"><b-button type="submit" variant="primary">SEARCH</b-button></div>

            </b-form>
        </div>

        <div style="display: block; margin-top: 10px; max-height: 600px; overflow-y: scroll;">
            <div v-if="items_being_loaded == true">
                <loading :active="true"
                :can-cancel="false"
                :is-full-page="false">
                </loading>
            </div>

            <div v-else-if="items_being_loaded == false">
                <div v-if="search_results.length > 0" style="overflow-x: auto;">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                                <th style="min-width: 120px;" class="srr">SALE DATE</th>
                                <th style="min-width: 100px;" class="srr">INVOICE #</th>
                                <th style="min-width: 100px;" class="srr">CUSTOMER NAME</th>
                                <th style="min-width: 100px;" class="srr">CUSTOMER PHONE</th>
                                <th style="min-width: 100px;" class="srr">CUSTOMER EMAIL</th>
                                <th style="min-width: 100px;" class="srr">CUSTOMER ZIPCODE</th>
                                <th style="min-width: 150px;" class="srr">SOLD FROM</th>
                                <th style="min-width: 100px;" class="srr">ACTION</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="sr,sridx in search_results" v-bind:key="sridx">
                                <td class="srrv">{{sr.ts}}</td>
                                <td class="srrv">{{sr.invoice_id}}</td>
                                <td class="srrv">{{sr.fullname}}</td>
                                <td class="srrv">{{sr.phone}}</td>
                                <td class="srrv">{{sr.email}}</td>
                                <td class="srrv">{{sr.zipcode}}</td>
                                <td class="srrv">{{packet.locsubsdict[sr.locsub]}}</td>
                                <td class="srrv"><b-button size="sm" variant="primary" @click="emit_back(sr)">SELECT</b-button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-else>
                    <b-alert show variant="warning">NO INVOICE FOR THE GIVEN SEARCH KEYWORD</b-alert>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'underscore'
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "IssueRefunds",
        components: {Backer,Loading},
        data: function(){
            return {
                packet: {},
                search_results: [],
                output: {},
                items_being_loaded: null,
                search_txt: null,
                invoice_selected: false,
                validated: false,
                invoice_id: null,

            }
        },
        methods: {
            emit_back: function(item){
                this.items_being_loaded = null;
                this.$emit("find-item", item)
            },
            is_plus_zero: function(value) {
                return 1/value === Infinity;
            },
            is_minus_zero: function(value) {
                return 1/value === -Infinity;
            },
            get_remaining: function(){
                let available_right_now = this.output.available_right_now;
                let current_issues = this.get_current_issues();
                let final = available_right_now - current_issues;
                if (this.is_minus_zero(final) && this.is_plus_zero(final) ){
                    final = 0.0;
                }
                return final;
            },
            get_current_issues: function(){
                let current_issues = 0.0;
                for (var i=0; i<this.output.pms.length; i++){
                    let pm = this.output.pms[i];
                    let amount = (parseFloat(pm.issue_amount) || 0.0);
                    current_issues += amount;
                }
                return current_issues;

            },
            validate_refund: function(){
                let errors = [];
                let available_right_now = (parseFloat(JSON.stringify(this.output.available_right_now)) || 0.0);

                for (var i=0; i<this.output.pms.length; i++){
                    let pm = this.output.pms[i];
                    let amount = (parseFloat(pm.issue_amount) || 0.0);

                    if (amount < 0.0){
                        errors.push({message: "NEGATIVE REFUND AMOUNTS ARE NOT ALLOWED."});
                    }
                    let max_allowed = pm.max_allowed;

                    if (amount <= max_allowed){
                        if (((available_right_now - amount) >= 0)) {
                            available_right_now -= amount;
                        }
                        else {
                            errors.push({message: "TOTAL REFUNDED IS EXCEEDING THE TOTAL AVAILABLE AMOUNT."})
                        }
                    }
                    else {
                        errors.push({message: "ANY AMOUNT CANNOT EXCEED ITS MAX ALLOWED AMOUNT."})
                    }
                }

                if (errors.length>0){
                    this.$vex.dialog.alert(
                        {message: errors[0].message}
                    );
                }
                else {
                    this.validated=true;
                }
                return
            },
            submit_refund: function(){
                let that = this;
                let path = "/api/sales/issue_sc_out/"
                let data = this.output;
                data.username = this.packet.userDetails.username;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );

                    }
                    else {
                        //that.output = response.data.result[0];
                        //that.calculate_allowed_percs();
                        that.$bvToast.toast(
                            "SUCCESSFULLY ISSUED REFUND.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.get_refunds_info({invoice_id: that.invoice_id});
                    }

                }
                let f = function(error){
                    that.$bvToast.toast(
                        "ERROR RETRIEVING THE INVOICE. PLEASE TRY AGAIN.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);

            },

            get_refunds_info: function(row){
                let invoice_id = row.invoice_id;
                this.invoice_id = invoice_id;

                let data = {invoice_id: invoice_id}
                let path = "/api/sales/retrieve_sc_for_refund/"
                let that = this;

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );

                    }
                    else {
                        that.output = response.data.result[0];
                        //that.calculate_allowed_percs();

                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "ERROR RETRIEVING THE INVOICE. PLEASE TRY AGAIN.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                this.invoice_selected = true;
                this.output = {};
                Requestor.getSyncP(path, data, this, s, f);

            },
            search_invoice: function(e){
                if (e){
                    e.preventDefault();
                }

                if (!this.search_txt || this.search_txt.length <= 1){
                    this.$vex.dialog.alert(
                        {message: "PLEASE PROVIDE A VALID NAME/INVOICE #/PHONE/EMAIL"}
                    );
                    return
                }

                let data = {search_txt: this.search_txt}
                let path = "/api/sales/search_invoice_id/"
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );

                    }
                    else {
                        that.search_results = response.data.result;
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "ERROR SEARCHING THE INVOICE. PLEASE TRY AGAIN.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                //console.log(data)
                this.items_being_loaded = true;
                this.invoice_selected = false;
                this.output = {};
                this.invoice_id = null;
                Requestor.getSyncP(path, data, this, s, f);
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
        }
    }
</script>

<style scoped>

    .srr {
        font-size: 14px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 14px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }


    .pth {
        font-size: 14px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .ptd {
        font-size: 14px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

</style>



// WEBPACK FOOTER //
// src/components/importables/InvoiceSearcher.vue